import { render, staticRenderFns } from "./BannerPreview.vue?vue&type=template&id=9f877336"
import script from "./BannerPreview.vue?vue&type=script&lang=js"
export * from "./BannerPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports